import React from 'react';
import PropTypes from 'prop-types';

// Helpers
import shareLink from 'services/shareLink';

// Styles
import styles from './embedControls.scss';

/**
 * A component that contains embed controls to embed the current view via
 * oEmbed or iframe.
 */
export default class EmbedControls extends React.PureComponent {
  /**
   * Renders the control based on the value of props.
   */
  render() {
    // Extract named properties from component props.
    const {
      dataView,
      geos,
      indicatorSubView,
      indicatorView,
      slug,
      timeframe,
    } = this.props;

    // Get the embed URL, provided the view props.
    const url = shareLink({
      dataView,
      geos,
      indicatorSubView,
      indicatorView,
      slug,
      timeframe,
    });

    const iframeUrl = url.replace(
      'https://www.prb.org/',
      'https://datacenter.prb.org/embed/'
    );

    return (
      <form>
        <ul className={styles.embedControls}>
          <li>
            <label htmlFor="embed-iframe">
              <p className={styles.label}>Copy and paste to embed:</p>
              <textarea
                id="embed-iframe"
                readOnly
                rows="3"
                value={`<iframe src="${iframeUrl}" style="height:100vh;width:100%"></iframe>`}
                className={styles.textarea}
              />
            </label>
          </li>
        </ul>
      </form>
    );
  }
}

EmbedControls.propTypes = {
  dataView: PropTypes.string.isRequired,
  geos: PropTypes.arrayOf(PropTypes.string),
  indicatorSubView: PropTypes.string,
  indicatorView: PropTypes.string,
  slug: PropTypes.string.isRequired,
  timeframe: PropTypes.number,
};

EmbedControls.defaultProps = {
  geos: [],
  indicatorSubView: '',
  indicatorView: '',
  timeframe: -1,
};



// WEBPACK FOOTER //
// ./app/components/embedControls/index.js